import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=1bc87ad3&scoped=true"
import script from "./AgentCard.vue?vue&type=script&lang=js"
export * from "./AgentCard.vue?vue&type=script&lang=js"
import style0 from "./AgentCard.vue?vue&type=style&index=0&id=1bc87ad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc87ad3",
  null
  
)

export default component.exports